import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./PointDetail.module.scss";

import SimpleButton from "../../atoms/simple-button/SimpleButton";
import accumulatePoint from "../../static/images/point/accumulate-point.png";
import letterDiagnosis from "../../static/images/point/letter-diagnosis.png";
import letterMISA from "../../static/images/point/letter-misa.png";
import letterQuiz from "../../static/images/point/letter-quiz.png";
import letterSavingMethod from "../../static/images/point/letter-saving-method.png";
import charQuiz from "../../static/images/point/chara-quiz.png";
import charSim from "../../static/images/point/chara-sim.png";
import gift from "../../static/images/point/gift.png";
import misa from "../../static/images/point/misa.png";
import letterUsing from "../../static/images/point/letter-using.png";
import line from "../../static/images/dashed-line.png";

const PointDetail = () => {
  const navigate     = useNavigate();

  return (
      <div className={classes.container}>
        <div className={classes.messageBlock}>
          <h1 className={classes.title}>「みらいいポイント」はより楽しく、</h1>
          <h1 className={classes.title}>学びを続けていただくための</h1>
          <h1 className={classes.title}>ポイントサービスです</h1>
          <div className={classes.spacer}></div>
          <p className={classes.text}>みらいいポイントは、○×クイズや診断をしたり、MISAで遊んだりするたびにどんどん貯まります♪</p>
        </div>
        <img src={accumulatePoint} alt="ポイントロゴ" className={classes.logo} />

        <div className={classes.savingblock}>
          <img src={letterSavingMethod} alt="貯め方ロゴ" className={classes.titlelogo} />
          <div className={classes.titleRow}>
            <span className={classes.titleText1}>貯め方</span>
            <span className={classes.titleText2}>１</span>
            <img src={letterDiagnosis} alt="診断ロゴ" />
          </div>
          <img className={classes.lineImage} src={line} alt="ライン" />
          <div className={classes.infoRow}>
            <img src={charSim} alt="診断キャラクター" className={classes.charImage} />
            <div className={classes.textBlock}>
              <p className={classes.mainText}>
                 診断を実施すると<br />
                「みらいいポイント」がもらえる！
              </p>
            </div>
          </div>
          <div className={classes.buttonArea}>
            <SimpleButton
              label="診断へ"
              width="90%"
              color="orange"
              isRadius={true}
              onClick={() => navigate("/diagnosis-list")}
            />
          </div>
          <div className={classes.titleRow}>
            <span className={classes.titleText1}>貯め方</span>
            <span className={classes.titleText2}>2</span>
            <img src={letterQuiz} alt="クイズロゴ" />
          </div>
          <img className={classes.lineImage} src={line} alt="ライン" />
          <div className={classes.infoRow}>
            <img src={charQuiz} alt="クイズキャラクター" className={classes.charImage} />
            <div className={classes.textBlock}>
              <p className={classes.mainText}>
                ログインや期間中にお題をクリアで<br />
                「みらいいポイント」がもらえる！
              </p>
            </div>
          </div>
          <div className={classes.buttonArea}>
            <SimpleButton
              label="○×クイズへ"
              width="90%"
              color="orange"
              isRadius={true}
              onClick={() => navigate("/quiz")}
            />
          </div>
          <div className={classes.titleRow}>
            <span className={classes.titleText1}>貯め方</span>
            <span className={classes.titleText2}>3</span>
            <img src={letterMISA} alt="MISAロゴ" />
          </div>
          <img className={classes.lineImage} src={line} alt="ライン" />
          <div className={classes.infoRow}>
            <img src={misa} alt="MISA説明イメージ" className={classes.charImage} />
            <div className={classes.textBlock}>
              <p className={classes.mainText}>
                MISAをプレイして<br />
                みらいいポイントを運用！
              </p>
            </div>
          </div>
          <div className={classes.buttonArea}>
            <SimpleButton
              label="MISAへ"
              width="90%"
              color="orange"
              isRadius={true}
              onClick={() => navigate("/misa-top")}
            />
          </div>
        </div>

        <div className={classes.giftBlock}>
          <img src={letterUsing} alt="使い方ロゴ" className={classes.titlelogo} />
          <h1 className={classes.title}>みらいいポイントをごほうびと交換！</h1>
          <h1 className={classes.subTitle}>※交換できる景品には期限や交換数に上限がある場合があります</h1>
          <h1 className={classes.subTitle}>※交換できる景品は予告なく入れ替わることがあります。</h1>
          <img src={gift} alt="ギフトロゴ" className={classes.logo} />
          <div className={classes.buttonArea}>
            <SimpleButton
              label="ごほうびをもらう！"
              width="90%"
              color="orange"
              isRadius={true}
              onClick={() => navigate("/point")}
            />
          </div>
        </div>
        <div className={classes.buttonArea}>
            <SimpleButton
              label="閉じる"
              width="90%"
              color="gray"
              isRadius={true}
              onClick={() => navigate("/point")}
            />
        </div>
      </div>
  );
};

export default PointDetail;
